import React from "react";
import { useFInfoCard } from "./hooks/useInfoCard";
import styles from "./style/FInfoCard.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { TrashIcon } from "@heroicons/react/solid";
import FiconPhoneNumber from "../FiconPhoneNumber/FiconPhoneNumber";
import Swal from "sweetalert2";
import { PencilOutline, Star, Trash } from "react-ionicons";

const FInfoCard = ({ title = "", typeOfContactId, contact, onDeleteClick = (data) => { }, onEditInfoCard = (data) => { }, item = [], trash = true, disable = false, star = false }) => {
  return (
    <>
      <div className={`border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 ${!disable ? "cursor-pointer" : "bg-backgroundInput"}`}>
        <div className="border-0 col-span-10 grid grid-cols-1 items-center font-regular text-[13px] pl-2">
          <div className="col-span-1 font-bold text-[17px]">{title}</div>
          <div className="col-span-1 font-regular text-[14px]">
            {typeOfContactId == "PHONE" ? (
              <FiconPhoneNumber sizeIcon="20px" phoneNumber={contact} />
            ) : (
              contact
            )}
          </div>
        </div>
        <div className="border-0 col-span-2 grid gap-1 grid-cols-1 place-items-center">
          <div className="border-0 cursor-pointer col-span-1">
            {star == true ? <Star height="21px" width="21px" color={"#2196f3"} /> : null}
            {trash == false ? star == true : item.isPrincipal ? (
              <Star height="21px" width="21px" color={"#2196f3"} />
            ) : (
              <Trash
                height="24px"
                width="24px"
                color={"#E30000"}
                onClick={() => {
                  Swal.fire({
                    showCloseButton: true,
                    title: `Eliminar ${typeOfContactId == "PHONE" ? "Teléfono" : "Email"
                      }`,
                    text: `¿Está seguro que desea eliminar este  ${typeOfContactId == "PHONE" ? "Teléfono" : "Email"
                      }?`,
                    imageUrl: require("../../components/assets/images/pregunta.png"),
                    imageWidth: 150,
                    imageHeight: 150,
                    imageAlt: "Custom image",
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      onDeleteClick(item);
                    }
                  });
                }}
              />
            )}
          </div>
          {
            item.isPrincipal ? null : (<div className="border-0 cursor-pointer col-span-1">
              {trash == false ? star == true : item.isPrincipal ? (
                null
              ) : (
                <PencilOutline
                  height="21px" width="21px"
                  cssClasses={"mt-2 cursor-pointer"}
                  onClick={onEditInfoCard}
                />
              )}
            </div>)
          }
        </div>
      </div>
    </>
  );
};

export default FInfoCard;